import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL } from '../apiConfig';
// Confirm you want my newsletter 
const ConfirmationPage = () => {
    const { token } = useParams();
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const confirmSubscription = async () => {
            try {
                const response = await fetch(`${API_URL}/api/confirm/${token}`);
                const data = await response.json();

                if (response.ok) {
                    setStatus('success');
                    setMessage(data.message);
                } else {
                    setStatus('error');
                    setMessage(data.detail || 'Something went wrong');
                }
            } catch (error) {
                setStatus('error');
                setMessage('Failed to confirm subscription');
            }
        };

        confirmSubscription();
    }, [token]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-pink-200 via-purple-200 to-blue-200 p-8 flex items-center justify-center">
            <div className="max-w-md w-full bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-8 text-center">
                {status === 'loading' && (
                    <>
                        <div className="text-6xl mb-4">⏳</div>
                        <h1 className="text-3xl font-bold text-purple-600 mb-4">
                            Confirming...
                        </h1>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div className="text-6xl mb-4">🎉</div>
                        <h1 className="text-3xl font-bold text-green-600 mb-4 font-cookie">
                            You're All Set!
                        </h1>
                        <p className="text-lg text-purple-700 mb-6">
                            {message}
                        </p>
                        <p className="text-purple-600">
                            Get ready for some amazing messages from your favorite character! 💖✨
                        </p>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="text-6xl mb-4">😢</div>
                        <h1 className="text-3xl font-bold text-red-600 mb-4">
                            Oops!
                        </h1>
                        <p className="text-lg text-gray-700">
                            {message}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default ConfirmationPage;
